import { render, staticRenderFns } from "./OrdersNew.vue?vue&type=template&id=06529110&"
import script from "./OrdersNew.vue?vue&type=script&lang=js&"
export * from "./OrdersNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports